<!-- @format -->

@if (universitySelections?.length > 1) {
  <div aria-labelledby="change-university" role="group" class="university-menu" [class.university-menu--mobile]="mobileMode">
    <div class="university-menu__header" aria-hidden="true" id="change-university">{{ "AUTH.UNIVERSITY" | translate }}</div>
    @for (university of universitySelections; track university) {
      <button
        type="button"
        ngbDropdownItem
        role="menuitem"
        (click)="changeUniversity(university.id)"
        (blur)="blurMobileUniversityMenu.emit($event)"
        (keydown.escape)="blurMobileUniversityMenu.emit($event)"
        (keydown)="keydownPressed.emit($event)"
        [attr.aria-current]="university.id === currentUniversityOrgId"
        class="university-menu__item">
        {{ university.name }}
        @if (university.id === currentUniversityOrgId) {
          <fudis-icon [icon]="'check'" [color]="'primary'" />
        }
      </button>
    }
  </div>
}
